import { Stack, Text, XStack, YStack } from "tamagui";
import { SUPPLIERS } from "@screen/Onboarding/suppliers";
import { kiosk } from "../kioskTheme";
import KioskIcon from "../KioskIcon";

/**
 * 下單前選瓦斯行：新客戶 / 未匹配到瓦斯行者，進一鍵下單前先選一家。
 * （demo 用 Onboarding 的 SUPPLIERS 清單；正式版改用 available_suppliers API。）
 */
const SupplierSelectSheet = ({ isOpen, onPick }: { isOpen: boolean; onPick: (supplierId: string) => void }) => {
  if (!isOpen) return null;
  return (
    <Stack position="absolute" t={0} l={0} r={0} b={0} backgroundColor={kiosk.bg} style={{ zIndex: 130 }}>
      <YStack px={20} pt={56} pb={14}>
        <Text fontSize={22} fontWeight="900" color={kiosk.ink} letterSpacing={-0.5}>
          選擇瓦斯行
        </Text>
        <Text fontSize={13.5} color={kiosk.grey} mt={6}>
          下單前請先選擇要服務您的瓦斯行
        </Text>
      </YStack>

      <YStack px={16} gap={12}>
        {Object.entries(SUPPLIERS).map(([id, s]) => (
          <XStack
            key={id}
            ai="center"
            gap={12}
            backgroundColor="#fff"
            borderWidth={1}
            borderColor={kiosk.line}
            borderRadius={16}
            p={14}
            cursor="pointer"
            pressStyle={{ scale: 0.99, backgroundColor: kiosk.pillBg }}
            onPress={() => onPick(id)}
            style={{ boxShadow: "0 8px 20px -16px rgba(20,40,90,.4)" }}>
            <Stack width={46} height={46} borderRadius={13} ai="center" jc="center" backgroundColor={kiosk.blue}>
              <KioskIcon name="cylinder" size={22} color="#fff" />
            </Stack>
            <YStack flex={1} minWidth={0}>
              <Text fontSize={16} fontWeight="800" color={kiosk.ink}>
                {s.name}
              </Text>
              <Text fontSize={12.5} color={kiosk.grey} mt={2}>
                {s.area} · {s.phone}
              </Text>
            </YStack>
            <Text fontSize={20} fontWeight="800" color={kiosk.blue}>
              ›
            </Text>
          </XStack>
        ))}
      </YStack>
    </Stack>
  );
};

export default SupplierSelectSheet;
